import {ModalDirective} from 'ngx-bootstrap/modal';
import {ActivatedRoute} from '@angular/router';
import {FrontendDocument, FrontendStatusEnum} from '@nachdigal';
import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ConversionHelper} from '../../helper/conversion.helper';
import {TaskDataService} from '@utils-lib';

@Component({
    selector: 'common-ui-conversion-hint',
    templateUrl: './conversion-hint.component.html',
    styleUrls: ['./conversion-hint.component.scss']
})
export class ConversionHintComponent implements OnInit, AfterViewInit {

    @ViewChild(ModalDirective) lgModal: ModalDirective;

    @Input()
    public context: string;
    public readonly versionChangeLink = 'https://apps.datev.de/help-center/documents/1021176';

    private frontendDocument: FrontendDocument;

    constructor(protected readonly activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.frontendDocument = this.activatedRoute.snapshot.parent.data.document;
    }

    ngAfterViewInit(): void {
        if (this.lgModal?.config) {
            this.lgModal.config.ignoreBackdropClick = true;
        }
        // if (ConversionHelper.isDraftInConversionRange(this.frontendDocument) && !this.checkConfirmationExists()) {
        if (this.checkConversionNeeded() && !this.checkConfirmationExists()) {
            this.lgModal?.show();
        }
    }

    saveConfirmation(): void {
        localStorage.setItem('conversion-confirmation-date', new Date().toLocaleString());
    }

    checkConfirmationExists(): boolean {
        return this.activatedRoute.snapshot.parent.data.taskData.metadaten.conversion_confirmation_date;
    }

    checkConversionNeeded(): boolean {
        return this.activatedRoute.snapshot.parent.data.taskData.metadaten.task_data_version &&
            this.activatedRoute.snapshot.parent.data.taskData.metadaten.task_data_version !== TaskDataService.TASK_DATA_VERSION &&
            this.frontendDocument.status === FrontendStatusEnum.Created;
    }

    public onConfirmHint(): void {
        this.saveConfirmation();
        this.lgModal.hide();
    }
}

